import React from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Grid from '@mui/material/Grid';
import { es } from 'date-fns/locale/es';

export default function DateRangePickerMUI({ ranges, onChange }) {
  const [selection] = ranges;

  const handleStartDateChange = (newDate) => {
    onChange({
      selection: {
        ...selection,
        startDate: newDate,
        key: 'selection'
      }
    });
  };

  const handleEndDateChange = (newDate) => {
    onChange({
      selection: {
        ...selection,
        endDate: newDate,
        key: 'selection'
      }
    });
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={es}>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <DatePicker
            label="Fecha Inicio"
            value={selection.startDate}
            onChange={handleStartDateChange}
            slotProps={{ textField: { fullWidth: true } }}
          />
        </Grid>
        <Grid item xs={6}>
          <DatePicker
            label="Fecha Fin"
            value={selection.endDate}
            onChange={handleEndDateChange}
            slotProps={{ textField: { fullWidth: true } }}
          />
        </Grid>
      </Grid>
    </LocalizationProvider>
  );
}
